import React from 'react';
import Main from './components/Main/index';
import { MARKET_REPORTS_SYSTEM_ID } from '@intelligence/pages/InsightsReport/_config';
import { GuideMarketReportsDelay as GuideMarketReports } from '@intelligence/components/UserGuide/MarketReports';

export default function MarketsReport() {
  return (
    <>
      <Main systemId={MARKET_REPORTS_SYSTEM_ID} />
      <GuideMarketReports />
    </>
  );
}
